import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchLessonLibrary = async () => (await axios.get(`${API}/connectlessen/library`)).data;

export const fetchLibraryLesson = async (lessonId) => (
  await axios.get(`${API}/connectlessen/library/${lessonId}`)
).data;
